export default "__VITE_ASSET__nDUcS156__"